import { api } from './api';

export interface AiResult {
  id: string;
  workspaceId: string;
  userId: string;
  agentKind: string;
  title: string;
  input: Record<string, unknown>;
  output: string;
  outputJson: unknown | null;
  model: string;
  costCents: number;
  citations: string[];
  pinned: boolean;
  createdAt: string;
}

export const aiResultsApi = {
  list: async (params: { workspaceId: string; agentKind?: string; limit?: number }) => {
    const r = await api.get<{ items: AiResult[] }>('/api/ai-results', { params });
    return r.data;
  },
  get: async (id: string) => {
    const r = await api.get<AiResult>(`/api/ai-results/${id}`);
    return r.data;
  },
  pin: async (id: string, pinned: boolean) => {
    const r = await api.post<AiResult>(`/api/ai-results/${id}/pin`, { pinned });
    return r.data;
  },
  remove: async (id: string) => {
    await api.delete(`/api/ai-results/${id}`);
  },
};
